import { IsBoolean, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';

export class OrderPositionGetRequest {
    @IsNumber()
    @IsNotEmpty()
    public id: number;

    @IsBoolean()
    @IsOptional()
    public valuesAsText?: boolean;

    constructor(data?: Partial<OrderPositionGetRequest>) {
        this.id = data?.id;
        this.valuesAsText = data?.valuesAsText;
    }
}
